<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="true">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="card" style="box-shadow: 0 0 5px gray;">
                  <div class="card-body">
                    <form @submit.prevent="AddtoCart">
                      <div class="form-group mb-2">
                        <label class="mb-0">Member</label>
                        <v-select :options="members" placeholder="Select a Member" v-model="member"
                          :reduce="member => member.member_id" label="name"></v-select>
                      </div>
                      <div class="mt-3 d-flex justify-content-between" v-if="member">
                        <small style="cursor: pointer;" class="border rounded border-primary px-1"
                          :class="{ 'bg-primary text-white fw-bold': show_saving }"
                          @click.prevent="show_saving = !show_saving; saving = ''; $nextTick(() => { $refs.savingInput.focus(); });">Saving</small>
                        <small style="cursor: pointer;" class="border rounded border-primary px-1"
                          :class="{ 'bg-primary text-white fw-bold': show_loan }"
                          @click.prevent="show_loan = !show_loan; loan = ''; $nextTick(() => { $refs.loanInput.focus(); });">Loan</small>
                        <small style="cursor: pointer;" class="border rounded border-primary px-1"
                          :class="{ 'bg-primary text-white fw-bold': show_cofu }"
                          @click.prevent="show_cofu = !show_cofu; cofu = ''; $nextTick(() => { $refs.cofuInput.focus(); });">COFU</small>
                        <small style="cursor: pointer;" class="border rounded border-primary px-1"
                          :class="{ 'bg-primary text-white fw-bold': show_subscription }"
                          @click.prevent="show_subscription = !show_subscription; subscription = ''; $nextTick(() => { $refs.subscriptionInput.focus(); });">Membership</small>
                      </div>
                      <hr>
                      <div v-if="show_saving" class="form-group mb-2">
                        <label class="mb-0">Saving Amount</label>
                        <input v-model="saving" type="number" class="form-control" ref="savingInput" />
                      </div>
                      <div v-if="show_loan" class="form-group mb-2">
                        <label class="mb-0">Loan Amount</label>
                        <input v-model="loan" type="number" class="form-control" ref="loanInput" />
                      </div>
                      <div v-if="show_cofu" class="form-group mb-2">
                        <label class="mb-0">Condolence Fund</label>
                        <input v-model="cofu" type="number" class="form-control" ref="cofuInput" />
                      </div>
                      <div v-if="show_subscription" class="form-group mb-2">
                        <label class="mb-0">Membership/Subscription Fee</label>
                        <input v-model="subscription" type="number" class="form-control" ref="subscriptionInput" />
                      </div>
                      <div class="form-group">
                        <button :disabled="!saving && !loan && !cofu && !subscription || !member"
                          class="btn btn-primary w-100"><i class="fas fa-check-circle"></i> Submit</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card" style="box-shadow: 0 0 2px gray;">
                  <span v-if="this.checkoffcarts.length <= 0">
                    <div class="d-flex justify-content-center p-5">
                      <span class="mdi mdi-cash text-success display-5"></span><br>
                      <span class="h4 mt-4">No Item Selected</span>
                    </div>
                  </span>
                  <span v-else>
                    <div class="table-responsive">
                      <b-table :items="Items" :fields="Fields" responsive="sm" :busy="IsBusy" sticky-header="400px"
                        striped>
                        <template #table-busy>
                          <div class="text-center text-primary my-2">
                            <b-spinner v-if="data_status == 'Fetching data...'" class="align-middle"
                              type="grow"></b-spinner>
                            <span v-else class="mdi mdi-cancel fs-1"></span>
                            <div class="fw-bold fs-5">{{ data_status }}</div>
                          </div>
                        </template>

                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>

                        <template #cell(member)="data">
                          <router-link :to="{
                            path: '/memberprofile',
                            query: { id: data.item.member.member_id },
                          }">
                            <span @mouseover="name_hover = true; current_index = data.index"
                              @mouseout="name_hover = false">
                              <span
                                :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                                  data.item.member.name }}</span>
                              <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                            </span>
                          </router-link>
                        </template>

                        <template #cell(saving)="data">
                          {{ commas(data.item.saving) }}
                        </template>

                        <template #cell(loan)="data">
                          {{ commas(data.item.loan) }}
                        </template>

                        <template #cell(cofu)="data">
                          {{ commas(data.item.cofu) }}
                        </template>

                        <template #cell(subscription)="data">
                          {{ commas(data.item.subscription) }}
                        </template>

                        <template #cell(actions)="data">
                          <b-button @click="remove(data.item.id, data.item.member)" type="button" class="btn-sm btn"
                            variant="danger" v-b-modal.delete-cart> <i class="mdi mdi-trash-can"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </div>
                    <div class="container">
                      <hr>
                    </div>
                    <div class="row mx-1 mb-2">
                      <div class="col-md-5">
                        <div class="form-group">
                          <label class="mb-0">Period</label>
                          <!-- <v-select :options="months" v-model="month" placeholder="Select Month"></v-select> -->
                          <input type="month" class="form-control" v-model="period">
                        </div>
                      </div>
                      <div class="col-2"></div>
                      <div class="col-md-5">
                        <b-button :disabled="!period" class="btn w-100 mt-3" @click="SubmitExit" variant="primary"><i
                            class="mdi mdi-check-circle"></i>
                          CREATE LIST</b-button>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Record Expenses</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="delete-cart" centered title="Delete From Cart" title-class="font-18" hide-footer>
      <form @submit.prevent="removeFromCart">
        Are you sure you want to remove the record for : <b>{{ member.name }}</b> ?
        <br>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-cart')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { checkoffCartComputed, checkoffCartMethods, memberComputed, memberMethods } from "../../../state/helpers";

export default {
  page: {
    title: "New Checkoff List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "New Checkoff List",
      items: [{ text: "Dashboard", href: "/" }, { text: "New Checkoff List", active: true }],
      isBusy: true,
      months: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ],
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'member', label: 'Member', visible: true },
        { key: 'saving', label: 'Saving', visible: true },
        { key: 'loan', label: 'Loan', visible: true },
        { key: 'cofu', label: 'COFU', visible: true },
        { key: 'subscription', label: 'Membership', visible: true },
        { key: 'actions', label: 'Remove', visible: true },
      ],
      id: '',
      member: '',
      saving: "",
      show_saving: false,
      loan: "",
      show_loan: false,
      cofu: "",
      show_cofu: false,
      subscription: "",
      current_index: 0,
      name_hover: false,
      show_subscription: false,
      list_name: '',
      month: '',
      period: '',
      paydate: new Date().toLocaleDateString('fr-CA'),
    };
  },
  methods: {
    ...checkoffCartMethods,
    ...memberMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },

    clearFields() {
      this.member = '';
      this.saving = '';
      this.show_saving = false;
      this.loan = '';
      this.show_loan = false;
      this.cofu = '';
      this.show_cofu = false;
      this.subscription = '';
      this.show_subscription = false;
    },

    remove(id, member) {
      this.id = id;
      this.member = member;
      this.$bvModal.show('delete-cart')
    },

    async AddtoCart() {
      const obj = {
        'member_id': this.member,
        'saving': this.saving,
        'loan': this.loan,
        'cofu': this.cofu,
        'subscription': this.subscription,
      }

      await axios.post('new-checkoff-cart', obj).then((response) => {
        if (response.status == 201) {
          this.$toast.success('Record added to cart');
          this.clearFields();
          this.fetchCheckoffCarts();
        }
        else {
          this.$toast.error('Error adding record to cart');
        }
      }).catch((error) => {
        alert(error);
      });

    },

    async removeFromCart() {
      await axios.post('delete-checkoff-cart', { 'id': this.id }).then((response) => {
        if (response.status == 200) {
          this.$toast.success('Record removed from cart');
          this.fetchCheckoffCarts();
          this.clearFields();
          this.$bvModal.hide('delete-cart');

        }
        else {
          this.$toast.error('Error removing record from cart');
        }
      })
    },

    async SubmitExit() {
      const obj = {
        'period': this.period,
      }
      await axios.post('submit-checkoff-cart', obj).then((response) => {
        if (response.status == 201) {
          this.$toast.success('Checkoff List Created');
          this.fetchCheckoffCarts();
          this.$router.push('/checkoff-lists');
        }
        else {
          this.$toast.error('Error creating checkoff list');
        }
      })
    },

  },
  computed: {
    ...checkoffCartComputed,
    ...memberComputed,
    cart_total() { var total = 0; this.checkoffcarts.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    amountpaid() { var total = 0; this.checkoffcarts.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    List() { return this.checkoffcarts.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.checkoffcarts.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.checkoffcarts.length > 0) { a = false; } else { a = true; } return a },
  },

  mounted() {
    this.isBusy = false;
    this.fetchCheckoffCarts();
    this.fetchMembers();
  }
};
</script>
